module.exports = __webpack_public_path__ + "img/2.d7371346.jpg";